const axios = require('axios');

class ApiClient {
    constructor(basePath) {
        this.basePath = basePath;
    }

    async request({
        path,
        method = 'get',
        body,
        query,
        token
    } = {}) {
        const headers = {};
        if (token) {
            headers.Authorization = `Bearer ${token}`;
        }
        const response = await axios({
            url: this.basePath + path,
            method,
            params: query,
            data: body,
            headers
        });
        return response.data;
    }

    async getList(path, query, token) {
        const body = await this.request({
            path,
            query,
            token,
        });
        return body.result;
    }

    async count(path, query, token) {
        const body = await this.request({
            path: `${path}/count/`,
            query,
            token,
        });
        return body.result;
    }

    async getOne(path, _id, token) {
        const body = await this.request({
            path: `${path}/${_id}`,
            token,
        });
        return body.result;
    }

    async create(path, object, token) {
        const body = await this.request({
            path,
            method: 'post',
            body: object,
            token,
        });
        return body.result;
    }

    async updateOne(path, _id, object, token) {
        const body = await this.request({
            path: `${path}/${_id}`,
            method: 'patch',
            body: object,
            token,
        });
        return body.result;
    }

    async recalculateAllUserStats(token) {
        const body = await this.request({
            path: '/users/recalculate-stats/',
            method: 'post',
            body: { force: true },
            token,
        });
        return body.result;
    }

    async updateUserProgramms(_id, object, token) {
        const body = await this.request({
            path: `/users/${_id}/programms`,
            method: 'put',
            body: object,
            token,
        });
        return body.result;
    }
}

module.exports = ApiClient;
